import { render, staticRenderFns } from "./DoubleAngleLeftSvg.vue?vue&type=template&id=8ab03e24&scoped=true&"
import script from "./DoubleAngleLeftSvg.vue?vue&type=script&lang=js&"
export * from "./DoubleAngleLeftSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab03e24",
  null
  
)

export default component.exports